import React, { useCallback, useState } from 'react';
import { SettingsItem, SettingsItemRightContent, } from 'design-system/SettingsItem';
import Modal from 'utils/packages/Modal';
import { IconLink } from 'design-system/icons/IconLink';
import { IconShare } from 'design-system/icons/IconShare';
import { IconTwoUser } from 'design-system/icons/IconTwoUser';
import { IconEmma } from 'design-system/icons';
import { StyleSheet, View } from 'react-native';
import { CardView, rem } from 'design-system';
import { openShare } from 'utils/packages/rnShare';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import IconCopy from 'design-system/icons/IconCopy';
import Text from 'design-system/Text';
import IconCheck from 'design-system/icons/IconCheck';
import useColors from 'hooks/useColors';
import Clipboard from '@react-native-clipboard/clipboard';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { isWeb } from '../../../constants';
const ModalContent = ({ space, fromEdit = false, }) => {
    const webStyles = useStyles(webStyleSet);
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const [linkCopied, setLinkCopied] = useState(false);
    const [codeCopied, setCodeCopied] = useState(false);
    const onInviteContacts = useCallback(() => {
        Modal.hide(() => {
            navigation.navigateDeprecated('InviteToSpace', { space, fromEdit });
        });
    }, [navigation, space, fromEdit]);
    const onShareWeb = useCallback((textToCopy, type) => {
        Clipboard.setString(textToCopy);
        if (type === 'link')
            setLinkCopied(true);
        else
            setCodeCopied(true);
        setTimeout(() => {
            if (type === 'link')
                setLinkCopied(false);
            else
                setCodeCopied(false);
        }, 3000);
    }, []);
    const onShareViaLink = useCallback(() => {
        if (isWeb)
            onShareWeb(space.accessLink, 'link');
        else
            Modal.hide(() => openShare({ message: space.accessLink }));
    }, [onShareWeb, space.accessLink]);
    const onShareSpaceCode = useCallback(() => {
        if (isWeb)
            onShareWeb(`Use this code to join the space ${space.name} in Emma:\n${space.accessCode}`, 'code');
        else
            Modal.hide(() => openShare({
                message: `Use this code to join the space ${space.name} in Emma:\n${space.accessCode}`,
            }));
    }, [onShareWeb, space.accessCode, space.name]);
    const renderContent = (<>
      <SettingsItem style={isWeb ? webStyles.settingsItem : undefined} icon={<IconLink gradientKey="skyBlue"/>} title="Share via link" description="They can open the link to join the space" onPress={onShareViaLink}>
        {isWeb ? (<SettingsItemRightContent>
            {linkCopied ? (<View style={[webStyles.baseButton, webStyles.copiedButton]}>
                <IconCheck color={colors.elements.green}/>
                <Text color={colors.elements.green} TextThin-14 numberOfLines={1}>
                  Link copied
                </Text>
              </View>) : (<IconCopy style={webStyles.copyIcon}/>)}
          </SettingsItemRightContent>) : null}
      </SettingsItem>
      <SettingsItem style={isWeb ? webStyles.settingsItem : undefined} icon={<IconShare gradientKey="orange"/>} title="Share space code" description="They can enter the code in Emma to join the space" onPress={onShareSpaceCode}>
        {isWeb ? (<SettingsItemRightContent>
            {codeCopied ? (<View style={[webStyles.baseButton, webStyles.copiedButton]}>
                <IconCheck color={colors.elements.green}/>
                <Text color={colors.elements.green} TextThin-14 numberOfLines={1}>
                  Link copied
                </Text>
              </View>) : (<IconCopy style={webStyles.copyIcon}/>)}
          </SettingsItemRightContent>) : null}
      </SettingsItem>
      {!isWeb && (<SettingsItem style={isWeb ? webStyles.settingsItem : undefined} icon={<IconTwoUser alt gradientKey="lightPurple"/>} title="Add from contacts" description="Add your friends from your contacts" onPress={onInviteContacts}/>)}
      <SettingsItem style={isWeb ? webStyles.settingsItem : undefined} icon={<IconEmma colorKey="brand"/>} title="Add by @EmmaTag" description="If you know their user handle, you can add them to the space" onPress={onInviteContacts}/>
    </>);
    return isWeb ? (<View style={webStyles.modalPadding}>
      <CardView webPadding style={webStyles.modalContent}>
        {renderContent}
      </CardView>
    </View>) : (renderContent);
};
export const ShareSpaceModal = {
    show: ({ fromEdit, space }) => {
        Modal.show(<ModalContent fromEdit={fromEdit} space={space}/>, {
            containerStyle: styles.modal,
            title: 'Add members',
            textStyle: styles.textStyle,
            lightBg: true,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
    },
    textStyle: {
        marginBottom: rem(8),
    },
    modalContent: {
        paddingTop: rem(16),
    },
});
const webStyleSet = createStyleSheets((colors) => ({
    modalPadding: {
        paddingTop: rem(8),
    },
    modalContent: {
        backgroundColor: colors.background.light,
        marginHorizontal: rem(16),
    },
    settingsItem: {
        marginVertical: rem(16),
    },
    baseButton: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    copiedButton: {
        justifyContent: 'center',
    },
    copyIcon: {
        marginRight: rem(6),
    },
}));
